import { authenticationService } from '../../services/auth.service';
import { Navigate } from 'react-router-dom';
import DashboardAuxiliarSec from '../dashboard-auxiliar-sec/DashboardAuxiliarSec';
import DashboardMain from '../dashboard-main/DashboardMain';
import { UserRoleEnum } from '../../models/enums/UserRoleEnum';

export default function Dashboard() {

  const handleDashboard = () => {
    if (authenticationService.isAuxSec()) {
      return <DashboardAuxiliarSec />
    }

    if (authenticationService.isYouth()) {
      return <Navigate to="/umadeub" replace />
    }

    
    if (authenticationService.isAuxCampaign()) {
      return <Navigate to="/campanhas/pessoas" replace />
    }

    if (authenticationService.currentUserRoles().includes(UserRoleEnum.FINANCE)) {
      return <Navigate to="/financeiro" replace />
    }

    return <DashboardMain />
  }

  return <div>{handleDashboard()}</div>
}